export default {"src":"/_next/static/media/wr.2b557dc9.svg","height":125,"width":125,"blurWidth":0,"blurHeight":0};